enum SituacaoEnum {
  Undefined = 'undefined',
  PreAgendamento = 'PreAgendamento',
  RevisaoCirurgica = 'RevisaoCirurgica',
  RevisaoCirurgicaAutorizacao = 'RevisaoCirurgicaAutorizacao',
  Divergente = 'Divergente',
  Provisionada = 'Provisionada',
  ValidacaoPendente = 'ValidacaoPendente',
  Validada = 'Validada',
  Paga = 'Paga',
  EnviadoParaPagamento = 'EnviadoParaPagamento',
  Incompleta = 'Incompleta',
  EmAnalise = 'EmAnalise',
  Pendente = 'Pendente',
  Autorizada = 'Autorizada',
  Negada = 'Negada',
  Agendada = 'Agendada',
  EmCancelamento = 'EmCancelamento',
  Cancelada = 'Cancelada',
  Enviado = 'Enviado',
  EmTriagem = 'EmTriagem',
  AlteracaoDeCarater = 'AlteracaoDeCarater',
  EmCotacao = 'EmCotacao',
  OrcamentoParticularAvulsoEmCotacao = 'OrcamentoParticularAvulsoEmCotacao',
  EmAutorizacao = 'EmAutorizacao',
  AguardandoIntegracaoOperadora = 'AguardandoIntegracaoOperadora',
  ErroIntegracaoOperadora = 'ErroIntegracaoOperadora',
  CriticaOperadora = 'CriticaOperadora',
  AnalisePreAutorizacao = 'AnalisePreAutorizacao',
  AnalisePreCotacao = 'AnalisePreCotacao',
  AnalisePosCotacao = 'AnalisePosCotacao',
  PendenteDeEnvioRoboDeAutorizacao = 'PendenteDeEnvioRoboDeAutorizacao',
  RetornoDeCotacao = 'RetornoDeCotacao',
  AguardandoOperadora = 'AguardandoOperadora',
  RespostaDoRoboDeAutorizacao = 'RespostaDoRoboDeAutorizacao',
  CancelamentoSolicitado = 'CancelamentoSolicitado',
  PendenciaRespondida = 'PendenciaRespondida',
  ContestacaoMedica = 'ContestacaoMedica',
  ContestacaoPendente = 'ContestacaoPendente',
  Contato = 'Contato',
  NovaDataSolicitada = 'NovaDataSolicitada',
  AutorizadaParcial = 'AutorizadaParcial',
  AutorizadaAceitaMedico = 'AutorizadaAceitaMedico',
  AceitaPeloMedico= 'AceitaPeloMedico',
  AutorizacaoPos = 'AutorizacaoPos',
  AguardandoSuprimentos = 'AguardandoSuprimentos',
  AguardandoOrcamento = 'AguardandoOrcamento',
  NovoOrcamentoParticular = 'NovoOrcamentoParticular',
  AguardandoGeracaoDaCobranca = 'AguardandoGeracaoDaCobranca',
  AguardandoPagamento = 'AguardandoPagamento',
  AguardandoAprovacaoOrcamento = 'AguardandoAprovacaoOrcamento',
  AguardandoOrcamentoParticularAvulso = 'AguardandoOrcamentoParticularAvulso',
  NovaSolicitacaoDeOrcamentoParticularAvulso = 'NovaSolicitacaoDeOrcamentoParticularAvulso',
  OrcamentoParticularAvulsoAguardandoSuprimentos = 'OrcamentoParticularAvulsoAguardandoSuprimentos',
  OrcamentoParticularAvulsoEnviado = 'OrcamentoParticularAvulsoEnviado',
  OrcamentoAprovado = 'OrcamentoAprovado',
  OrcamentoRecusado = 'OrcamentoRecusado',
  OrcamentoCancelado = 'OrcamentoCancelado',
  LiberadoSuprimentos = 'LiberadoSuprimentos',
  PendenteReservaDeMaterial = 'PendenteReservaDeMaterial',
  NovaSolicitacaoParticular = 'NovaSolicitacaoParticular',
  AguardandoReservaHis = 'AguardandoReservaHis',
  AguardandoAlteracaoDeReservaHis = 'AguardandoAlteracaoDeReservaHis',
  ReenvioDeReservaHis = 'ReenvioDeReservaHis',
  ErroReservaHis = 'ErroReservaHis',
  ErroAoAlterarReservaHis = 'ErroAoAlterarReservaHis',
  PendenciaAdministrativa = 'PendenciaAdministrativa',
  RetornoDaAutorizacaoDoHis = 'RetornoDaAutorizacaoDoHis',
  AguardandoAutorizacao = 'AguardandoAutorizacao',
  AutorizacaoNegada = 'AutorizacaoNegada',
  Realizada = 'Realizada',
  AguardandoNegociacaoParticular = 'AguardandoNegociacaoParticular',
  AnalisePreAutorizacaoUrgencia = 'AnalisePreAutorizacaoUrgencia',
  AguardandoAutorizacaoUrgencia = 'AguardandoAutorizacaoUrgencia',
  AguardandoPrazoPosTriagem = 'AguardandoPrazoPosTriagem',
  PendenteReserva = 'PendenteReserva',
  PendenteAjusteData = 'PendenteAjusteData',
  PendenteAjusteMaterial = 'PendenteAjusteMaterial',
  PendenteCancelamento = 'PendenteCancelamento',
  Concluido = 'Concluido',
  AguardandoPriorizacao = 'AguardandoPriorizacao',
  AutorizadoParaAgendar = 'AutorizadoParaAgendar',
}

export default SituacaoEnum
